import { Component } from "@angular/core";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Feature } from "@interfaces/feature.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { ExportLogService } from "@services/exportLog.service";
import { FeatureService } from "@services/feature.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "features",
	styleUrls: ["features.css"],
	templateUrl: "features.html"
})
export class FeatureAdminComponent {
	canExportGrid = false;
	features: Feature[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [
		{ icon: "fal fa-plus", method: "addNewItem", text: "New Feature" }
	];
	title = "Features";

	constructor(private toastService: ToastService, private featureService: FeatureService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.getFeatures();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		// TODO: Add new
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Features")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getFeatures() {
		this.featureService.getAll()
			.subscribe(
				(res: any) => this.features = res.response.items,
				(err) => console.log(err),
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Features";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}
}